module.exports = __webpack_public_path__ + "static/media/20_galeria_plantillas_combo_simple_rec_18.cac7a0d9.png";